import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { catchError } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class InsightApiService {

    data = {
        speed: [{
        lable: 'Correct',
        score: '500',
        total: '75m 10s',
        speed: '03m 13s'
        },{
          lable: 'Partially Correct',
          score: '130',
          total: '65m 20s',
          speed: '03m 13s'
          },{
            lable: 'Incorrect',
            score: '120',
            total: '65m 20s',
          speed: '03m 13s'
            },{
              lable: 'Not Answered',
              score: '90',
              total: '65m 20s',
          speed: '03m 13s'
              }],
        average:'03m 13s'
      }

    constructor(private http: HttpClient ,private cookieService: CookieService) { }

    userReports():Observable <any> {
      return this.http.get<any>(`${environment.userHost}/insight_test_status/${this.cookieService.get('_PAOID')}`)
    }
    insightRecentActivity():Observable <any> {
        return this.http.get<any>(`${environment.userHost}/insight_recent_activity/${this.cookieService.get('_PAOID')}`)
      }

    testSummaryTableData(tempTestStatus:any):Observable <any>{
        return this.http.get<any>(environment.userHost + '/insight_test_status_tabular/'+this.cookieService.get('_PAOID')+'/'+tempTestStatus)
    }
    
    activityLogTableData(tempTestStatus:any):Observable <any>{
        return this.http.get<any>(environment.userHost + '/activity_log_drill/'+this.cookieService.get('_PAOID')+'/'+tempTestStatus)
  
    }

    insightTestNameDropData():Observable <any>{
        return this.http.get<any>(environment.userHost + '/insight_test_drop_down/'+this.cookieService.get('_PAOID'))
  
    }

    insightTestInfo(body:any): Observable<any>{
        body.org_id = this.cookieService.get('_PAOID')
        return this.http.post<any>(environment.userHost + '/insight_test_info', body)
    }

    
    insightTestWisePerformanceSummarySpeed(body:any){
        body.org_id = this.cookieService.get('_PAOID')
        // return this.data;
        return this.http.post<any>(environment.userHost + '/insight_test_wise_performance_summary_speed', body)
    }

    insightTestWisePerformanceSummaryAccuracy(body:any){
        body.org_id = this.cookieService.get('_PAOID');
        // let newData = JSON.parse(JSON.stringify(this.data))
        // let datas = newData.speed.map(e => ({ ...e, total: `${this.getRandomTwoDigit()}%`, speed: `${this.getRandomTwoDigit()}%` }))
        // newData.speed = datas;
        // newData.average = '54.02%'

        // return newData;
        // return this.http.post<any>(environment.userHost + '/insight_test_wise_performance_summary_accuracy', body)
        return this.http.post<any>(environment.userHost + '/insight_test_wise_performance_summary_accuracy', body)
        .pipe(
            map((response: any) => {
                // Assuming response contains 'speed' array inside each object
                // response.speed.forEach((item: any) => {
                    response.speed = response.speed.map((speedItem: any) => {
                    return {
                      ...speedItem,
                      speed: `${speedItem.percentage}%` // Add new 'speed' key to each object
                    };
                  });
                // });
                response.average = `${response.average}%`
                return response; // Return the modified response
              })
        );
    }
    getRandomTwoDigit() {
        return Math.floor(Math.random() * 90) + 10;  // Random number between 10 and 99
    }
    

    sectionWisePerformance(body:any) {
        let data = [
            {
            section_name: 'Math-I',
            data: [
                {
                    label: 'No. of Items',
                    value: '20'
                },
                {
                    label: 'Answered',
                    value: '10'
                },{
                    label: 'Marked for Review (Answered)',
                    value: '8'
                },{
                    label: 'Marked for Review (Unanswered)',
                    value: '5'
                },{
                    label: 'Not Answered',
                    value: '0'
                },
                // {
                    
                //     lebal: 'Section Score',
                //     value:'10/20'
                // }
            ]
            },
            {
                section_name: 'Math-II',
                data: [
                    {
                        label: 'No. of Items',
                        value: '20'
                    },
                    {
                        label: 'Answered',
                        value: '10'
                    },{
                        label: 'Marked for Review (Answered)',
                        value: '8'
                    },{
                        label: 'Marked for Review (Unanswered)',
                        value: '5'
                    },{
                        label: 'Not Answered',
                        value: '0'
                    },
                    // {
                        
                    //     lebal: 'Section Score',
                    //     value:'10/20'
                    // }
                ]
            }
        ]

        // return data;

        body.org_id = this.cookieService.get('_PAOID')
        // return this.data;
        return this.http.post<any>(environment.userHost + '/insight_section_wise_performance_summary_tabular', body)
    }

    sectionWiseSeepdAndAccuracy(body:any) {
        body.org_id = this.cookieService.get('_PAOID')
        // return this.data;
        return this.http.post<any>(environment.userHost + '/insight_section_wise_performance_summary', body)

        // return {
        //     speed: this.insightTestWisePerformanceSummarySpeed({}),
        //     accuracy: this.insightTestWisePerformanceSummaryAccuracy({})
        // }
    }

    

    insightPerformanceAnalyticsTopics(body:any) {
        body.org_id = this.cookieService.get('_PAOID')
        switch (body.Parameter) {
            case 'topic':
                return this.http.post<any>(environment.userHost + '/insight_performance_analytics_topics', body)
               
                case 'subject':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_subject', body)
               
                case 'difficulty':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_difficulty', body)
              
                case 'taxonomy':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_taxonomy', body)
               
                case 'item_type':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_item_type', body)
             
            default:
                break;
        }
    }

    insightPerformanceAnalyticsGraph(body:any) {
        body.org_id = this.cookieService.get('_PAOID')
        switch (body.Parameter) {
            case 'topic':
                return this.http.post<any>(environment.userHost + '/insight_performance_analytics_chart_topics', body)
               
                case 'subject':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_chart_subject', body)
               
                case 'difficulty':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_chart_difficulty', body)
              
                case 'taxonomy':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_chart_taxonomy', body)
               
                case 'item_type':
                    return this.http.post<any>(environment.userHost + '/insight_performance_analytics_chart_item_type', body)
             
            default:
                break;
        }
    }

    insightSheetDownload(body:any) {
        body.org_id = this.cookieService.get('_PAOID');
        return this.http.post<any>(environment.userHost + '/insight_performance_analytics_report_download', body)
    }

    insightCompetencyAnalysis(body:any) {
        body.org_id = this.cookieService.get('_PAOID')
        return this.http.post<any>(environment.userHost + '/insight_competency_analysis', body);
    }

}



// WEBPACK FOOTER //
// ./src/app/application/services/api-service/insight-api.service.ts